import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=e49e59c6&scoped=true&"
import script from "./UserNotifications.vue?vue&type=script&lang=js&"
export * from "./UserNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49e59c6",
  null
  
)

export default component.exports